// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "button[data-v-4c538fdf]:first-of-type{margin-right:1.5rem}.alert-banner[data-v-4c538fdf]{margin:0 1.5rem}.inline-loader[data-v-4c538fdf]{display:inline-block}", ""]);
// Exports
module.exports = exports;
